<template>
  <transition name="slideup">
    <div
      v-if="dataIsLoad && isOpen"
      id="dialog-market"
      :class="{ active: isOpen }"
      class="dialog-bottom dialog-item"
    >
      <div class="dialog-mask mask" data-target="#dialog-market" @click.prevent="closeSelf" />
      <div class="dialog-bottom-content">
        <div class="item-info">
          <div class="d-flex">
            <div class="col-8">
              <div class="item-name">
                {{ allData.Name }}
              </div>
              <small v-if="selectedSpec !== null && selectedSpec.PreOrder">
                {{ allData.ArrivalExplanation }}
              </small>
              <div class="item-price">
                <span class="sell-price">{{ currencyPrice(mapSellPrice) }}</span>
                <span
                  v-if="allData.SellPrice !== allData.OriginPrice || allData.EventPrice > 0"
                  class="origin-price"
                >
                  {{ currencyPrice(allData.OriginPrice) }}
                </span>
              </div>
              <div v-for="event in allData.Events" :key="event.ID" class="event-text">
                <span class="free-label">活動</span>
                <span>{{ event.Name }}</span>
              </div>
              <ul class="product-color-wrap">
                <li
                  v-for="color in allData.Colors"
                  :key="color.ID"
                  class="product-color"
                  :class="{ active: color.ID === selected.ID }"
                  @click="changeImg(color.ID)"
                >
                  <img class="m-0" :src="color.PintSizePictureUrl + '?w=16&h=16'" />
                </li>
              </ul>
            </div>
            <div class="col-4">
              <NewImage
                v-if="selected.Images.length !== 0"
                :url="selected.Images[0].Url"
                class="dialog-img"
                :size="'_w700_h1050'"
                :name="allData.Name"
              />
            </div>
          </div>
          <div class="select-container">
            <div class="col-6">
              <p class="mb-1">SIZE</p>
              <Selector
                :options="selected.Specs"
                :default-txt="'Select Size'"
                :selected="selectedSpec"
                :is-mobile="true"
                @cb="selectSpec"
              />
            </div>
            <div class="col-6">
              <p class="mb-1">Quantity</p>
              <div class="UiQuantity">
                <button class="btn UiQuantity__btn float-left" @click.prevent="reduceCount">
                  –
                </button>
                <span class="UiQuantity__text">{{ counter }}</span>
                <button
                  class="btn UiQuantity__btn float-right"
                  @click.prevent="addCount(selectedSpec === null ? 1 : selectedSpec.Stock)"
                >
                  ＋
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="dialog-bottom-container">
          <button
            class="btn dialog-bottom-btn"
            :class="btnStyleGenerate"
            @click.prevent="addToCart"
          >
            {{ btnDescriptionGenerate }}
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import $ from 'jquery';
import axios from 'axios';
import AlertDialog from '@global/helpers/alertDialog';
import NewImage from '@global/components/global/image';

import gtmTrace from '@global/components/tracing/gtm';
import utmKDetect from '@global/helpers/utmKDetect';
import Selector from '@page/common/js/template/Select.vue';
import { createNamespacedHelpers } from 'vuex';
import { fireAddToCart } from '@global/gtm/common';

const { mapActions } = createNamespacedHelpers('miniCartModule');

export default {
  components: { NewImage, Selector },
  props: ['isnotice'],
  data() {
    return {
      btnDescriptionType: {
        genernal: '請選擇尺寸',
        addbag: 'ADD TO CART',
        soldout: 'SOLD OUT',
        preShow: 'COMING SOON',
        notice: '索取貨到通知',
      },
      btnStyle: 'disabled',
      btnDescription: '請選擇尺寸',
      allData: {},
      selectedID: null,
      selected: {},
      isOpen: false,
      selectedSpec: { Name: 'Select Size', Key: 'default', ID: 'default' },
      selectedSpecKey: null,
      counter: 1,
      dataIsLoad: false,
      openArrivalNotice: false,
      itemSpecInfo: '',
    };
  },
  computed: {
    btnStyleGenerate: {
      get() {
        if (this.allData.IsPreShow) {
          this.btnStyle = 'disabled';
        }
        return this.btnStyle;
      },
      set(newVal) {
        this.btnStyle = newVal;
      },
    },
    btnDescriptionGenerate: {
      get() {
        if (this.allData.IsPreShow) {
          this.btnDescription = this.btnDescriptionType.preShow;
        } else if (this.isnotice) {
          this.btnDescription = this.btnDescriptionType.notice;
        }
        return this.btnDescription;
      },
      set(newVal) {
        this.btnDescription = newVal;
      },
    },
    mapSellPrice() {
      const price =
        this.allData.EventPrice > 0 && this.allData.EventPrice < this.allData.SellPrice
          ? this.allData.EventPrice
          : this.allData.SellPrice;
      return price;
    },
  },
  watch: {
    selectedID() {
      this.getSelectedData();
    },
  },
  methods: {
    ...mapActions(['getCartInfo']),
    currencyPrice(price) {
      const currentCurrency = this.allData.CurrentCurrency;
      const priceString = price.toLocaleString();
      let combinePrice = '';
      if (currentCurrency === 'TWD') {
        combinePrice = `NT$ ${priceString}`;
      } else if (currentCurrency === 'USD') {
        combinePrice = `US$ ${priceString}`;
      } else {
        combinePrice = `${priceString}`;
      }
      return combinePrice;
    },
    closeArrivalNotice() {
      this.openArrivalNotice = false;
    },
    getSelectedData() {
      this.allData.Colors.forEach((element, index) => {
        if (element.ID === this.selectedID) {
          this.selected = element;

          if (this.selected.Specs.length === 1) {
            this.selectSpec(this.selected.Specs[0]);
          }
        }
      });
    },
    closeSelf() {
      this.isOpen = false;
      this.btnReset();
      this.clearSpec();
    },
    selectSpec(spec) {
      this.selectedSpec = spec;
      this.selectedSpecKey = spec.Key;
      this.counter = 1;
      this.btnActive(spec);
    },
    /**
     * @param {Number} stock 庫存數量
     * @param {Boolean} isSoldOut 是否為斷貨
     * @param {Boolean} isPreOrder 是否為預購商品
     */
    btnActive(spec) {
      if (this.allData.IsPreShow) return;
      if (spec.Key === 'default') {
        this.btnStyleGenerate = 'disabled';
        this.btnDescriptionGenerate = this.btnDescriptionType.genernal;
        return;
      }

      const { stock, isSoldOut, isPreOrder } = {
        stock: spec.Stock,
        isSoldOut: spec.IsOutOfStock,
        isPreOrder: spec.PreOrder,
      };

      if (stock === 0 && isSoldOut && !isPreOrder) {
        // 現貨無庫存且斷貨
        this.btnStyleGenerate = 'disabled';
        this.btnDescriptionGenerate = this.btnDescriptionType.soldout;
      } else if (stock === 0) {
        // 現貨無庫存
        this.btnStyleGenerate = 'active-mail';
        this.btnDescriptionGenerate = this.btnDescriptionType.notice;
      } else {
        this.btnStyleGenerate = 'active';
        this.btnDescriptionGenerate = this.btnDescriptionType.addbag;
      }
    },
    addCount(maxCount) {
      if (this.selectedSpec.Key === 'default') return;
      if (this.counter >= maxCount || this.counter >= 10) return;
      this.counter += 1;
    },
    reduceCount() {
      if (this.counter <= 1) return;
      this.counter -= 1;
    },
    changeImg(colorID) {
      if (this.selected.ID === colorID) return;
      this.btnReset();
      this.clearSpec();
      this.counter = 1;
      this.selectedID = colorID;
    },
    btnReset() {
      this.btnStyleGenerate = 'disabled';
      this.btnDescriptionGenerate = this.btnDescriptionType.genernal;
    },
    clearSpec() {
      this.selectedSpec = { Name: 'Select Size', Key: 'default' };
      this.selectedSpecKey = null;
    },
    addToCart() {
      if (this.allData.IsPreShow) return;
      if (this.selectedSpec.Key === 'default') {
        AlertDialog.alert('請選擇尺寸');
        return;
      }

      const custommarketid = this.allData.CustomMarketID;
      const itemSpecInfo = `${custommarketid.substring(0, custommarketid.indexOf('CL'))}CL${
        this.selectedID
      }SZ${this.selectedSpecKey}`;
      this.itemSpecInfo = itemSpecInfo;

      this.$emit('changecmid', itemSpecInfo);

      if (this.selectedSpec.Stock === 0) {
        if (this.selectedSpec.IsOutOfStock && !this.selectedSpec.PreOrder) {
          // 庫存為0且為斷貨商品且不是預購商品
          return;
        }
        // 1.庫存為0且不是斷貨商品(不用管預購不預購)
        // 2.庫存為0且是斷貨商品但為預購商品
        $('#lb-get-product-mail').modal('show');
        return;
      }

      const utmData = utmKDetect(itemSpecInfo) === null ? '' : utmKDetect(itemSpecInfo);

      axios
        .post(API_URL.SHOPPING_CART, {
          CustomMarketID: itemSpecInfo,
          Count: this.counter,
          UtmTag: utmData,
        })
        .then((res) => {
          if (res.data.Code === 200 || res.data.Code === 406) {
            this.getCartInfo();
            $('#cart-menu').toggleClass('active');
            $('.open-sideba').toggleClass('active');
            $('#cart-mask').toggleClass('active');
            if ($('.open-sideba').hasClass('active')) {
              $('body').addClass('lock-page');
            } else {
              $('body').removeClass('lock-page');
            }

            gtmTrace.addToCart({
              name: this.allData.Name,
              id: itemSpecInfo,
              price: this.allData.OriginPrice_TW,
              sale_price:
                this.allData.EventPrice_TW > 0 &&
                this.allData.EventPrice_TW < this.allData.SellPrice_TW
                  ? this.allData.EventPrice_TW
                  : this.allData.SellPrice_TW,
              color: this.selected.Name,
              count: this.counter,
            });

            fireAddToCart({
              item_id: itemSpecInfo.split('SZ')[0],
              item_name: this.allData.Name,
              index: 0,
              affiliation: this.selected.Name,
              item_brand: this.selectedSpec.Name,
              item_list_name: '產品內頁',
              price:
                this.allData.EventPrice_TW > 0 &&
                this.allData.EventPrice_TW < this.allData.SellPrice_TW
                  ? this.allData.EventPrice_TW
                  : this.allData.SellPrice_TW,
              quantity: this.counter,
              item_variant: this.selectedSpec.Barcode,
            });

            this.closeSelf();
          } else if (res.data.Code === 205) {
            AlertDialog.alert('商品已售完', () => {
              window.location.reload();
            });
          } else {
            AlertDialog.alert(res.data.Message);
          }
        })
        .catch((error) => {
          AlertDialog.alert(error);
        });
    },
  },
};
</script>
